import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    exceptRoleIds?: string[];
}

type Props = IProps & Omit<IAutoCompleteProps, 'onGetSuggestions'>;


////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de papeis para cadastros
 * @param props
 */
export const SecurityRoleAutoComplete: React.FC<Props> = ({ onError, ...props }) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.suggestions.securityRoles({
                name: searchText,
                exceptRoleIds: props.exceptRoleIds ?? [],
                pageNumber: pageNumber,
                pageSize: pageSize,
            }, { signal })
            .then(result => resolve({
                items: result.data.items as AutoCompleteDataModel[],
                totalRows: result.data.totalRows
            }))
            .catch(error => {
                if (!isCanceledError(error)) {
                    resolve({ items: [], totalRows: 0 });
                    if (onError) onError(error);
                }
            });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onGetSuggestions={getSuggestions}
        />
    );
};
